<template>
  <div class="home">
    <!-- <ReportsAW :config="config" /> -->
    <template v-if="showSeniors">
      <ReportsSA :config="config" />
    </template>

    <template v-else-if="showAus === 'Y' || showWpg === 'Y'">
      <ReportsAW :config="config" />
    </template>

    <template v-else>
      <ReportsSA :config="config" />
    </template>
  </div>
</template>

<script>
import ReportsAW from "@/components/reportsAW.vue";
import ReportsSA from "@/components/reportsSA.vue";
import axios from "axios";
export default {
  name: "Full Reports", 
  props:["config"],
  components: { 
    ReportsAW,
    ReportsSA
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    return {
     showAus: 'N',
     showWpg: 'N',
     showSnr: 'N',
     showAll: 'N',
     showSeniors: false
    };
  },
  mounted() {
    const url = `https://api.aus.ocs-software.com/pgaaus/cache/aus/tmticx?multi=Y&tour=aus&tour=wpg&tour=snr&maxdays=10&days=-5&randomadd=${Date.now()}`;

    axios.get(url)
      .then(({ data }) => {
        const getTournament = tour => data?.[tour]?.[0]?.[0]?.data;

        const ausTournament = getTournament('aus');
        const wpgTournament = getTournament('wpg');
        const seniorsTournament = getTournament('snr');

        const isRunning = tournament =>
          tournament &&
          Number(tournament.days_away) <= 0 &&
          tournament.ts_final_result !== 'Y';

        const ausRunning = isRunning(ausTournament);
        const wpgRunning = isRunning(wpgTournament);
        const seniorsRunning = isRunning(seniorsTournament);

        this.showAus = ausTournament ? 'Y' : 'N';
        this.showWpg = wpgTournament ? 'Y' : 'N';
        this.showSnr = seniorsTournament ? 'Y' : 'N';

        this.showSeniors =
          seniorsRunning && !ausRunning && !wpgRunning;
      })
      .catch(error => {
        console.error('API error:', error);
      });
  }
};
</script>
